import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function formatDateIt(isoDate: string): string {
  const [y, m, d] = isoDate.split('-');
  const months = [
    'gennaio', 'febbraio', 'marzo', 'aprile', 'maggio', 'giugno',
    'luglio', 'agosto', 'settembre', 'ottobre', 'novembre', 'dicembre',
  ];
  const monthIdx = Number.parseInt(m ?? '0', 10) - 1;
  if (monthIdx < 0 || monthIdx > 11) return isoDate;
  return `${Number.parseInt(d ?? '0', 10)} ${months[monthIdx]} ${y}`;
}

export function formatDateShort(isoDate: string): string {
  const [y, m, d] = isoDate.split('-');
  return `${d}/${m}/${y}`;
}
